var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error_message !== '')?_c('article',[_c('h3',[_vm._v("異常原因:")]),_c('section',[_vm._v(_vm._s(_vm.error_message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }